export const TOOLTIP_OPEN = "tooltip.open"
